import * as ui from '@april9au/stack9-ui';

import { AppRoutes } from '../../constants/appRoutes';
import { Industry } from '../../models/stack9/Industry';
import { IndustryForm } from './IndustryForm';

const { ScreenProvider } = ui;
const S9Drawer = ui.S9Drawer.default;

type IndustryDrawerProps = {
  id: number;
  open: boolean;
  onClose: () => void;
  initialValues?: Partial<Industry>;
};

export const IndustryDrawer = ({
  id,
  open,
  onClose,
  initialValues,
}: IndustryDrawerProps) => (
  <ScreenProvider relativePath={AppRoutes.CountrySetupDetail}>
    <S9Drawer open={open} width={650} onClose={onClose} closable>
      <IndustryForm initialValues={initialValues} id={id} onClose={onClose} />
    </S9Drawer>
  </ScreenProvider>
);
